import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { FormGroupDirective } from "@angular/forms";
import { FormGroup, FormText } from "@coso/forms";
import { ISiteDistribution, Period, PeriodName, PeriodSource, PeriodSourceName, SiteRule, SiteRuleName } from "../../../../models/auto-generated";
import { Language, LanguageName } from "../../models/language";
import { BehaviorSubject } from "rxjs";

@Component({
  standalone:false,
  templateUrl: "./site-settings.component.html",
  styleUrls: ["./site-settings.component.scss"]
})
export class SiteSettingsComponent implements OnInit {
  readonly WebTemplateApiEndpoint = "<site_url>/_api/web/getAvailableWebTemplates(1033)";
  @ViewChild("siteNamingRulePopover", { static: true }) siteNamingRulePopover: TemplateRef<any>;
  @ViewChild("periodPopover", { static: true }) periodPopover: TemplateRef<any>;
  @ViewChild("periodSourcePopover", { static: true }) periodSourcePopover: TemplateRef<any>;
  @ViewChild("libraryNamePopover", { static: true }) libraryNamePopover: TemplateRef<any>;
  @ViewChild("characterCountPopover", { static: true }) characterCountPopover: TemplateRef<any>;
  @ViewChild("siteNamePopover", { static: true }) siteNamePopover: TemplateRef<any>;
  @ViewChild("webTemplatePopover", { static: true }) webTemplatePopover: TemplateRef<any>;
  SiteRule = SiteRule;
  Period = Period;
  formGroup: FormGroup<ISiteDistribution>;
  formText: FormText<ISiteDistribution>;
  isReadOnly = new BehaviorSubject<boolean>(false);

  get isReadOnly$() {
    return this.isReadOnly.asObservable();
  }

  constructor(private rootFormGroupDirective: FormGroupDirective) {}

  ngOnInit(): void {
    this.formGroup = this.rootFormGroupDirective.control.get("siteDistribution") as FormGroup<ISiteDistribution>;
    this.formText = {
      pattern: {
        label: "Site Naming Rule",
        labelClass: "col-lg-3",
        inputContainerClass: "col-lg-5",
        popover: this.siteNamingRulePopover,
        options: Object.keys(SiteRule)
          .filter((k) => isNaN(Number(k)))
          .map((k) => ({ label: SiteRuleName.get(SiteRule[k]), value: SiteRule[k] }))
      },
      webTemplate: {
        label: "Web Template Name",
        labelClass: "col-lg-3",
        inputContainerClass: "col-lg-5",
        popover: this.webTemplatePopover,
        errors: {
          required: "The Web Template Name field is required."
        }
      },
      language: {
        label: "Language",
        labelClass: "col-lg-3",
        inputContainerClass: "col-lg-5",
        popover: "The natural language used to create a site in SharePoint. The default value is 1033 (English).",
        options: Object.keys(Language)
          .filter((k) => isNaN(Number(k)))
          .map((k) => ({ label: LanguageName.get(Language[k]), value: Language[k] }))
      },
      period: {
        label: "Period",
        labelClass: "col-lg-3",
        inputContainerClass: "col-lg-5",
        popover: this.periodPopover,
        options: [
          { label: "Select a period", value: null, disabled: true },
          ...Object.keys(Period)
            .filter((k) => isNaN(Number(k)))
            .map((k) => ({ label: PeriodName.get(Period[k]), value: Period[k] }))
        ],
        errors: {
          required: "The Site Name field is required."
        }
      },
      periodSource: {
        label: "Period Data Source",
        labelClass: "col-lg-3",
        inputContainerClass: "col-lg-5",
        popover: this.periodSourcePopover,
        options: Object.keys(PeriodSource)
          .filter((k) => isNaN(Number(k)))
          .map((k) => ({ label: PeriodSourceName.get(PeriodSource[k]), value: PeriodSource[k] }))
      },
      namePattern: {
        label: "Site Name",
        labelClass: "col-lg-3",
        inputContainerClass: "col-lg-5",
        popover: this.siteNamePopover,
        errors: {
          required: "The Period field is required."
        }
      },
      characterCount: {
        label: "Number of Characters",
        labelClass: "col-lg-3",
        inputContainerClass: "col-lg-5",
        popover: this.characterCountPopover,
        errors: {
          required: "The Number of Characters field is required.",
          min: "The Number of Characters field must be greater than or equal to 1.",
          max: "The Number of Characters field must be less than or equal to 16.",
          pattern: "The Number of Characters field must contain only numbers."
        }
      },
      unknownCharacter: {
        label: "Unknown Character",
        labelClass: "col-lg-3",
        inputContainerClass: "col-lg-5",
        popover: "The character used to replace characters that are non-alphanumeric in the document library name.",
        errors: {
          required: "The Unknown Character field is required.",
          maxlength: "The maximum length allowed in the Unknown Character field is 1 characters."
        }
      }
    };
  }
}
